import { Injectable, } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { finalize } from 'rxjs/operators';
import { consultaDiscrepanciasDTO, CriterioSimilitudDTO, modeloDTO, debitosDTO, debitosConsulta, reportesDTO, segurosDTO, solucionarDiscrepanciaDTO, CriterioSimilitudModificarDTO, vinDTO, visitaExistenteDTO, vinsVisitaDTO, codificacionModelosDTO } from '../entidades/entidades.component';

@Injectable({
  providedIn: 'root'
})
export class AveriasService {
  token: string;
  httpOptions;
  httpOptionsABM;
  constructor(private http: HttpClient) {
    this.updateToken();
  }

  URL_InspeccionTotal = `${environment.URL_InspeccionTotal}`;

  updateToken() {
    this.token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json; charset=UTF-8', 'Authorization': 'Bearer ' + this.token
      })
    };
    this.httpOptionsABM = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json; charset=UTF-8', 'Authorization': 'Bearer ' + this.token
      }),
      observe: 'response'
    };
  }
  
  //#region Grupo Tipo   
  getGrupoTipo(idCliente: number) {
    this.updateToken();
    return this.http.get(this.URL_InspeccionTotal + 'v1/grupos-tipos-averias/ListaGrupoTipoAveria?page=0&size=9999&sort=id&idCliente=' + idCliente, this.httpOptions);
  }
  getGrupoTipoPorId(idGrupoTipo: number) {
    this.updateToken();
    return this.http.get(this.URL_InspeccionTotal + 'v1/grupos-tipos-averias/' + idGrupoTipo, this.httpOptions);
  }
  postGrupoTipo(guardarGrupoTipo) {
    this.updateToken();
    return this.http.post(this.URL_InspeccionTotal + 'v1/grupos-tipos-averias/', guardarGrupoTipo, this.httpOptionsABM)
      .pipe(
        catchError(this.handleError)
      );
  }
  putGrupoTipo(idGrupoTipo: number, grupoTipo: any) {
    this.updateToken();
    return this.http.put(this.URL_InspeccionTotal + 'v1/grupos-tipos-averias/' + idGrupoTipo, grupoTipo, this.httpOptionsABM)
      .pipe(
        catchError(this.handleError)
      );
  }
  deleteGrupoTipoPorId(idGrupoTipo: number) {
    this.updateToken();
    return this.http.delete(this.URL_InspeccionTotal + 'v1/grupos-tipos-averias/' + idGrupoTipo, this.httpOptionsABM);
  }
  //#endregion

  //#region  Tipo
  getTipo(idCliente: number) {
    this.updateToken();
    return this.http.get(this.URL_InspeccionTotal + 'v1/tipos-averias/ListaTipoAveria?page=0&size=9999&sort=descripcion&idCliente=' + idCliente, this.httpOptions);
  }
  getTipoPorId(idTipo: number) {
    this.updateToken();
    return this.http.get(this.URL_InspeccionTotal + 'v1/tipos-averias/' + idTipo, this.httpOptions);
  }
  postTipo(guardarTipo) {
    this.updateToken();
    return this.http.post(this.URL_InspeccionTotal + 'v1/tipos-averias', guardarTipo, this.httpOptionsABM)
      .pipe(
        catchError(this.handleError)
      );
  }
  putTipo(idTipo: number, tipo: any) {
    this.updateToken();
    return this.http.put(this.URL_InspeccionTotal + 'v1/tipos-averias/' + idTipo, tipo, this.httpOptionsABM)
      .pipe(
        catchError(this.handleError)
      );
  }
  deleteTipo(idTipo: number) {
    this.updateToken();
    return this.http.delete(this.URL_InspeccionTotal + 'v1/tipos-averias/' + idTipo, this.httpOptionsABM)
  }
  //#endregion

  //#region  Area
  getArea(idCliente: number) {
    this.updateToken();
    return this.http.get(this.URL_InspeccionTotal + 'v1/areas/ListaArea?page=0&size=9999&sort=id&idCliente=' + idCliente, this.httpOptions)
  }
  getAreaPorId(idArea: number) {
    this.updateToken();
    return this.http.get(this.URL_InspeccionTotal + 'v1/areas/' + idArea, this.httpOptions)
  }
  postArea(guardarArea) {
    this.updateToken();
    return this.http.post(this.URL_InspeccionTotal + 'v1/areas', guardarArea, this.httpOptionsABM)
      .pipe(
        catchError(this.handleError)
      );
  }
  deleteArea(idArea: number) {
    this.updateToken();
    return this.http.delete(this.URL_InspeccionTotal + 'v1/areas/' + idArea, this.httpOptionsABM)
  }
  putArea(idArea: number, area: any) {
    this.updateToken();
    return this.http.put(this.URL_InspeccionTotal + 'v1/areas/' + idArea, area, this.httpOptionsABM)
      .pipe(
        catchError(this.handleError)
      );
  }
  //#endregion

  //#region Origen
  getOrigen(idCliente: number) {
    this.updateToken();
    return this.http.get(this.URL_InspeccionTotal + 'v1/origenes?page=0&size=9999&sort=id&idCliente=' + idCliente, this.httpOptions)
  }
  getOrigenPorId(idOrigen: number) {
    this.updateToken();
    return this.http.get(this.URL_InspeccionTotal + 'v1/origenes/' + idOrigen, this.httpOptions)
  }
  postOrigen(guardarOrigen) {
    this.updateToken();
    return this.http.post(this.URL_InspeccionTotal + 'v1/origenes', guardarOrigen, this.httpOptionsABM)
      .pipe(
        catchError(this.handleError)
      );
  }
  deleteOrigen(idOrigen: number) {
    this.updateToken();
    return this.http.delete(this.URL_InspeccionTotal + 'v1/origenes/' + idOrigen, this.httpOptionsABM)
  }
  putOrigen(idOrigen: number, origen: any) {
    this.updateToken();
    return this.http.put(this.URL_InspeccionTotal + 'v1/origenes/' + idOrigen, origen, this.httpOptionsABM)
      .pipe(
        catchError(this.handleError)
      );
  }
  //#endregion

  //#region  Severidad
  getSeveridad(idCliente: number) {
    this.updateToken();
    return this.http.get(this.URL_InspeccionTotal + 'v1/severidades/ListaSeveridad?page=0&size=9999&sort=id&idCliente=' + idCliente, this.httpOptions)
  }
  getSeveridadPorId(idSeveridad: number) {
    this.updateToken();
    return this.http.get(this.URL_InspeccionTotal + 'v1/severidades/' + idSeveridad, this.httpOptions)
  }
  postSeveridad(guardarSeveridad) {
    this.updateToken();
    return this.http.post(this.URL_InspeccionTotal + 'v1/severidades', guardarSeveridad, this.httpOptionsABM)
      .pipe(
        catchError(this.handleError)
      );
  }
  deleteSeveridad(idSeveridad: number) {
    this.updateToken();
    return this.http.delete(this.URL_InspeccionTotal + 'v1/severidades/' + idSeveridad, this.httpOptionsABM)
  }
  putSeveridad(idSeveridad: number, severidad: any) {
    this.updateToken();
    return this.http.put(this.URL_InspeccionTotal + 'v1/severidades/' + idSeveridad, severidad, this.httpOptionsABM)
      .pipe(
        catchError(this.handleError)
      );
  }
  //#endregion

  //#region Clasificacion
  getClasificacion(idCliente: number) {
    this.updateToken();
    return this.http.get(this.URL_InspeccionTotal + 'v1/clasificaciones?page=0&size=9999&sort=id&idCliente=' + idCliente, this.httpOptions)
  }
  getClasificacionPorId(idClasificacion: number) {
    this.updateToken();
    return this.http.get(this.URL_InspeccionTotal + 'v1/clasificaciones/' + idClasificacion, this.httpOptions)
  }
  postClasificacion(guardarClasificacion) {
    this.updateToken();
    return this.http.post(this.URL_InspeccionTotal + 'v1/clasificaciones', guardarClasificacion, this.httpOptionsABM)
      .pipe(
        catchError(this.handleError)
      );
  }
  deleteClasificacion(idClasificacion: number) {
    this.updateToken();
    return this.http.delete(this.URL_InspeccionTotal + 'v1/clasificaciones/' + idClasificacion, this.httpOptionsABM)
  }
  putClasificacion(idClasificacion: number, clasificacion: any) {
    this.updateToken();
    return this.http.put(this.URL_InspeccionTotal + 'v1/clasificaciones/' + idClasificacion, clasificacion, this.httpOptionsABM)
      .pipe(
        catchError(this.handleError)
      );
  }
  //#endregion

  //#region  Componente
  getComponente(idCliente: number) {
    this.updateToken();
    return this.http.get(this.URL_InspeccionTotal + 'v1/componentes?page=0&size=9999&sort=id&idCliente=' + idCliente, this.httpOptions)
  }
  getComponentePorId(idComponente: number) {
    this.updateToken();
    return this.http.get(this.URL_InspeccionTotal + 'v1/componentes/' + idComponente, this.httpOptions)
  }
  postComponente(guardarComponente) {
    this.updateToken();
    return this.http.post(this.URL_InspeccionTotal + 'v1/componentes', guardarComponente, this.httpOptionsABM)
      .pipe(
        catchError(this.handleError)
      );
  }
  deleteComponente(idComponente: number) {
    this.updateToken();
    return this.http.delete(this.URL_InspeccionTotal + 'v1/componentes/' + idComponente, this.httpOptionsABM)
  }
  putComponente(idComponente: number, componente: any) {
    this.updateToken();
    return this.http.put(this.URL_InspeccionTotal + 'v1/componentes/' + idComponente, componente, this.httpOptionsABM)
      .pipe(
        catchError(this.handleError)
      );
  }

  //#endregion

  //#region  Area Componente
  getAreaComponente(idCliente: number) {
    this.updateToken();
    return this.http.get(this.URL_InspeccionTotal + 'v1/areas-componentes/ListaAreaComponente?page=0&size=9999&sort=id&idCliente=' + idCliente, this.httpOptions)
  }
  putAreaComponente(idAreaComponente: number, areaComponente: any) {
    this.updateToken();
    return this.http.put(this.URL_InspeccionTotal + 'v1/areas-componentes/' + idAreaComponente, areaComponente, this.httpOptionsABM)
  }
  postAreaComponente(areaComponente) {
    this.updateToken();
    return this.http.post(this.URL_InspeccionTotal + 'v1/areas-componentes', areaComponente, this.httpOptionsABM)
      .pipe(
        catchError(this.handleError)
      );
  }
  deleteAreaComponente(idAreaComponente: number) {
    this.updateToken();
    return this.http.delete(this.URL_InspeccionTotal + 'v1/areas-componentes/' + idAreaComponente, this.httpOptionsABM)
  }
  //#endregion

  //#region Operadores
  getOperadoresVisita(): Observable<any> {
    this.updateToken();
    return this.http.get(this.URL_InspeccionTotal + 'v1/operadores/getOperadoresVisita?page=0&size=9999&sort=descripcion', this.httpOptions)
      .pipe(
        catchError(this.handleErrorInf)
      );
  }
  getOperadoresPorCliente(clienteId: number): Observable<any> {
    let cliente = {
      idCliente: clienteId
    }
    this.updateToken();
    return this.http.post(this.URL_InspeccionTotal + 'v1/operadores/ListaOperadoresPorCliente', cliente, this.httpOptions)
      .pipe(
        catchError(this.handleErrorInf)
      );
  }
  getOperadoresNavieraPorCliente(clienteId: number): Observable<any> {
    let cliente = {
      idCliente: clienteId
    }
    this.updateToken();
    return this.http.post(this.URL_InspeccionTotal + 'v1/operadores/ListaOperadoresNavieraPorCliente', cliente, this.httpOptions)
  }
  getClientesOperadoresPorCliente(clienteId: number): Observable<any> {
    let cliente = {
      idCliente: clienteId
    }
    return this.http.post(this.URL_InspeccionTotal + 'v1/clientes-operadores/ListaClientesOperadoresPorCliente', cliente, this.httpOptions)
      .pipe(
        catchError(this.handleErrorInf)
      )
  }
  getOperadores(): Observable<any> {
    this.updateToken();
    return this.http.get(this.URL_InspeccionTotal + 'v1/operadores?page=0&size=9999&sort=id', this.httpOptions).pipe(
      catchError(this.handleErrorInf)
    );
  }
  getOperadoresPorId(id: number): Observable<any> {
    this.updateToken();
    return this.http.get(this.URL_InspeccionTotal + 'v1/operadores/' + id, this.httpOptions)
  }
  postOperadores(guardarOperador) {
    this.updateToken();
    return this.http.post(this.URL_InspeccionTotal + 'v1/operadores', guardarOperador, this.httpOptionsABM)
      .pipe(
        catchError(this.handleError)
      );
  }
  ListaOperadores(idCliente: any): Observable<any> {
    this.updateToken();
    return this.http.post(this.URL_InspeccionTotal + 'v1/operadores/ListaOperadoresPorCliente', idCliente, this.httpOptions)
  }
  putOperadores(idOperadores: number, operadores: any): Observable<any> {
    this.updateToken();
    return this.http.put(this.URL_InspeccionTotal + 'v1/operadores/' + idOperadores, operadores, this.httpOptionsABM)
  }
  deleteOperadores(idOperadores: number) {
    this.updateToken();
    return this.http.delete(this.URL_InspeccionTotal + 'v1/operadores/' + idOperadores, this.httpOptionsABM)
  }
  //#endregion

  //#region TipoOperador
  getTipoOperador() {
    this.updateToken();
    return this.http.get(this.URL_InspeccionTotal + 'v1/tipos-operadores?page=0&size=9999&sort=id', this.httpOptions)
  }
  //#endregion

  //#region  Zona Cuadrante
  getZonaCuadrante(idCliente: number) {
    var resp;
    this.updateToken();
    resp = this.http.get(this.URL_InspeccionTotal + 'v1/zonas-cuadrantes?page=0&size=9999&sort=id&idCliente=' + idCliente,
      this.httpOptions
    )
    return resp;
  }
  //#endregion

  //#region Discrepancias
  ListaDiscrepancias(datos: consultaDiscrepanciasDTO): Observable<any> {
    this.updateToken();
    return this.http.post<XMLHttpRequest>(this.URL_InspeccionTotal + 'v1/discrepancias/ListaDiscrepancias', datos, this.httpOptions)
  }

  SolucionarDiscrepancias(datos: solucionarDiscrepanciaDTO): Observable<any> {
    this.updateToken();
    return this.http.post<XMLHttpRequest>(this.URL_InspeccionTotal + 'v1/discrepancias/SolucionarDiscrepancia', datos, this.httpOptionsABM)
  }
  //#endregion

  //#region Zona cuadrante detalle
  getZonaCuadranteDetalle(idCliente: number) {
    this.updateToken();
    return this.http.get(this.URL_InspeccionTotal + 'v1/zonas-cuadrantes-detalles?page=0&size=9999&sort=id&idCliente=' + idCliente, this.httpOptions)
  }

  getZonaCuadranteDetallePorAreaComponente(idAreaComponente: number) {
    let areaComponente = {
      idAreaComponente: idAreaComponente
    }
    this.updateToken();
    return this.http.post<XMLHttpRequest>(this.URL_InspeccionTotal + 'v1/zonas-cuadrantes-detalles/ListaZonaCuadranteDetallePorAreaComponente', areaComponente, this.httpOptions)
      .pipe(
        catchError(this.handleErrorInf)
      );
  }

  //region Clientes 
  getClientes() {
    this.updateToken();
    return this.http.get(this.URL_InspeccionTotal + 'v1/clientes?page=0&size=9999&sort=id', this.httpOptions)
  }
  //#endregion

  //#region Debitos Seguros
  guardarDebitos(debitos: debitosDTO[]) {
    this.updateToken();
    return this.http.post<XMLHttpRequest>(this.URL_InspeccionTotal + 'v1/zonas-cuadrantes-detalles?page=0&size=9999&sort=id', debitos, this.httpOptionsABM)
  }
  guardarSeguros(seguros: segurosDTO[]) {
    this.updateToken();
    return this.http.post<XMLHttpRequest>(this.URL_InspeccionTotal + 'v1/zonas-cuadrantes-detalles?page=0&size=9999&sort=id', seguros, this.httpOptionsABM)
  }

  listaDebitos(debitos: debitosConsulta[]) {
    this.updateToken();
    return this.http.post(this.URL_InspeccionTotal + 'v1/vin-averias/ListaAverias', debitos, this.httpOptionsABM)
  }

  actualizarDebitosPagosSeguros(obj) {
    this.updateToken();
    return this.http.put(this.URL_InspeccionTotal + 'v1/vin-averias/ActualizarDebitosPagosSeguro', obj, this.httpOptionsABM)
      .pipe(
        catchError(this.handleErrorInf)
      );
  }
  //#endregion

  //#region Consulta Averias
  getAverias(filtrosDTO): Observable<any> {
    return this.http.post<XMLHttpRequest>(this.URL_InspeccionTotal + 'v1/vin-averias/ListaAverias', filtrosDTO, this.httpOptionsABM)
    // .pipe(
    //   catchError(this.handleErrorInf)
    // );
  }

  getAveriasPorVin(filtrosDTO): Observable<any> {
    return this.http.post<XMLHttpRequest>(this.URL_InspeccionTotal + 'v1/vin-averias/AveriasPorVin', filtrosDTO, this.httpOptionsABM)
    // .pipe(
    //   catchError(this.handleErrorInf)
    // );
  }

  deleteAverias(id: number) {
    this.updateToken();
    return this.http.delete(this.URL_InspeccionTotal + 'v1/vin-averias/' + id, this.httpOptionsABM)

  }
  getListaAverias(filtrosDTO): Observable<any> {
    return this.http.post<XMLHttpRequest>(this.URL_InspeccionTotal + 'v1/inspecciones-vin-averias/ListaInspeccionAverias', filtrosDTO, this.httpOptionsABM)
  }
  getListaInspeccionAveriasPorOperador(filtrosDTO): Observable<any> {
    return this.http.post<XMLHttpRequest>(this.URL_InspeccionTotal + 'v1/inspecciones-vin-averias/ListaInspeccionAveriasPorOperador', filtrosDTO, this.httpOptionsABM)
  }
  getDetalleAveria(idAve): Observable<any> {
    this.updateToken();
    return this.http.post<XMLHttpRequest>(this.URL_InspeccionTotal + 'v1/vin-averias/DetalleAveria', idAve, this.httpOptions)
  }
  getDetalleInspeccionAveria(idAveria): Observable<any> {
    this.updateToken();
    return this.http.post<XMLHttpRequest>(this.URL_InspeccionTotal + 'v1/inspecciones-vin-averias/DetalleInspeccionAveria', idAveria, this.httpOptions)
  }
  editDetalleAveria(obj): Observable<any> {
    this.updateToken();
    return this.http.put<XMLHttpRequest>(this.URL_InspeccionTotal + 'v1/vin-averias/EditarAverias', obj, this.httpOptionsABM)
      .pipe(
        catchError(this.handleErrorInf)
      );
  }
  //#endregion

  getMaestros(idCliente: number): Observable<any> {
    this.updateToken();
    var cliente = {
      idCliente: idCliente
    }
    return this.http.post<XMLHttpRequest>(this.URL_InspeccionTotal + 'v1/parametros/ListaMaestros', cliente, this.httpOptions)
      .pipe(
        catchError(this.handleErrorInf)
      );
  }
  //#region Visitas
  getTipoProcesosVisita(): Observable<any> {
    this.updateToken();
    return this.http.get(this.URL_InspeccionTotal + 'v1/tipos-procesos/getTipoProcesosVisita?page=0&size=9999&sort=id', this.httpOptions).pipe(
      catchError(this.handleErrorInf)
    );
  }
  validarVisitaExistente(datos: visitaExistenteDTO): Observable<any> {
    this.updateToken();
    return this.http.post<XMLHttpRequest>(this.URL_InspeccionTotal + 'v1/visita/validarVisitaExistente', datos, this.httpOptionsABM)
  }
  saveVisita(datos: vinsVisitaDTO) {
    this.updateToken();
    return this.http.post(this.URL_InspeccionTotal + 'v1/visita', datos, this.httpOptionsABM)
      .pipe(
        catchError(this.handleError)
      );
  }

  deleteVisita(idVisita: number): Observable<any> {
    return this.http.delete(this.URL_InspeccionTotal + 'v1/visita/' + idVisita, this.httpOptionsABM)
  }

  //#endregion
  //#region Reportes
  postGenerarReporte(datosReporte: reportesDTO): Observable<any> {
    this.updateToken();
    return this.http.post<XMLHttpRequest>(this.URL_InspeccionTotal + 'v1/reportes/GenerarReporte', datosReporte, this.httpOptionsABM)

  }

  //#endregion

  //#region buques
  postListaBuquesPorOperador(idOperador: number) {
    let operador = {
      idOperador: idOperador
    }
    this.updateToken();
    return this.http.post<XMLHttpRequest>(this.URL_InspeccionTotal + 'v1/buques/ListaBuquesPorOperador', operador, this.httpOptionsABM)
  }
  getBuques(): Observable<any> {
    this.updateToken();
    return this.http.get(this.URL_InspeccionTotal + 'v1/buques?page=0&size=9999&sort=descripcion', this.httpOptions)
  }
  postBuques(guardarBuques): Observable<any> {
    this.updateToken();
    return this.http.post<XMLHttpRequest>(this.URL_InspeccionTotal + 'v1/buques', guardarBuques, this.httpOptionsABM)
      .pipe(
        catchError(this.handleError)
      );
  }
  putBuques(idBuques: number, buques: any) {
    this.updateToken();
    return this.http.put(this.URL_InspeccionTotal + 'v1/buques/' + idBuques, buques, this.httpOptionsABM)
      .pipe(
        catchError(this.handleError)
      );
  }

  deleteBuques(idBuques): Observable<any> {
    this.updateToken();
    return this.http.delete(this.URL_InspeccionTotal + 'v1/buques/' + idBuques, this.httpOptionsABM)
      .pipe(
        catchError(this.handleError)
      );
  }
  //#endregion

  //#region Criterio similitud

  postSimilitud(similitud: CriterioSimilitudDTO): Observable<any> {
    this.updateToken();
    return this.http.post<XMLHttpRequest>(this.URL_InspeccionTotal + 'v1/parametros/CriterioSimilitud', similitud, this.httpOptionsABM);
  }
  postSimilitudModificar(similitud: CriterioSimilitudModificarDTO) {
    this.updateToken();
    return this.http.post(this.URL_InspeccionTotal + 'v1/criterios-similitudes/EditarCriterioSimilitud', similitud, this.httpOptionsABM)
      .pipe(
        catchError(this.handleError)
      );
  }
  ListaSimilitud(idCliente: any): Observable<any> {
    this.updateToken();
    return this.http.post(this.URL_InspeccionTotal + 'v1/criterios-similitudes/ListaCriterioSimilitud', idCliente, this.httpOptionsABM)
      .pipe(
        catchError(this.handleErrorInf)
      );
  }
  altaSimilitud(similitud: any) {
    this.updateToken();
    return this.http.post(this.URL_InspeccionTotal + 'v1/criterios-similitudes/RegistrarCriterioSimilitud', similitud, this.httpOptionsABM)
  }
  getSimilitud() {
    this.updateToken();
    return this.http.get(this.URL_InspeccionTotal + 'v1/criterios-similitudes', this.httpOptions)
  }
  //#endregion

  //#region ClientesOperadores
  altaClienteOperador(obj): Observable<any> {
    this.updateToken();
    return this.http.post<XMLHttpRequest>(this.URL_InspeccionTotal + 'v1/clientes-operadores/', obj, this.httpOptionsABM)
  }
  bajaClienteOperador(id: number): Observable<any> {
    this.updateToken();
    return this.http.delete<XMLHttpRequest>(this.URL_InspeccionTotal + 'v1/clientes-operadores/' + id, this.httpOptionsABM)
  }
  //#endregion

  // #region Modelos
  getModelos(idCliente: any): Observable<any> {
    this.updateToken();
    return this.http.get(this.URL_InspeccionTotal + 'v1/modelos?page=0&size=9999&sort=id', this.httpOptions);
  }
  // Guarda los modelos
  postModelos(modelo: modeloDTO): Observable<any> {
    this.updateToken();
    return this.http.post(this.URL_InspeccionTotal + 'v1/modelos', modelo, this.httpOptionsABM)
  }
  putModelos(idModelo: number, modelo: modeloDTO): Observable<any> {
    this.updateToken();
    return this.http.put(this.URL_InspeccionTotal + 'v1/modelos/' + idModelo, modelo, this.httpOptionsABM)
      .pipe(
        catchError(this.handleError)
      );
  }

  deleteModelos(id: number): Observable<any> {
    return this.http.delete(this.URL_InspeccionTotal + 'v1/modelos/' + id, this.httpOptionsABM)
  }
  //#endregion

  //#region  vin
  getVinModelos(idCliente: number) {
    this.updateToken();
    return this.http.get(this.URL_InspeccionTotal + `v1/codificacionModelos/listModelos/${idCliente}`, this.httpOptions);
    //devuelve: codificacion, descripcion y descripcionAbreviada
  }
  // Guarda la codificacion modelo
  saveModelo(codificacionModelo: codificacionModelosDTO) {
    this.updateToken();
    return this.http.post(this.URL_InspeccionTotal + 'v1/codificacionModelos', codificacionModelo, this.httpOptionsABM)
      .pipe(
        catchError(this.handleErrorInfsinAlert)
      )
  }
  // 
  putVin(idVin: number, vin: codificacionModelosDTO): Observable<any> {
    return this.http.put(this.URL_InspeccionTotal + 'v1/codificacionModelos/' + idVin, vin, this.httpOptionsABM)
      .pipe(
        catchError(this.handleError)
      );
  }
  // Nuevo put
  putCodificacion(idCod: number, cod: codificacionModelosDTO): Observable<any> {
    return this.http.put(this.URL_InspeccionTotal + 'v1/codificacionModelos/codificacion/' + idCod, cod, this.httpOptionsABM)
      .pipe(
        catchError(this.handleError)
      );
  }
  putModeloBycodificacion(idCod: number, cod: modeloDTO): Observable<any> {
    return this.http.put(this.URL_InspeccionTotal + 'v1/codificacionModelos/codificacionModelo/' + idCod, cod, this.httpOptionsABM)
      .pipe(
        catchError(this.handleError)
      );
  }
  //
  deleteCodificacion(id: number): Observable<any> {
    return this.http.delete(this.URL_InspeccionTotal + 'v1/codificacionModelos/' + id, this.httpOptionsABM)
  }
  vinsConInspeccionPrevia(idCliente: number, datos: string[]) {
    this.updateToken();
    return this.http.post(this.URL_InspeccionTotal + 'v1/inspecciones-vin/vinsConInspeccionPrevia/' + idCliente, datos, this.httpOptionsABM)
      .pipe(
        catchError(this.handleError)
      );
  }


  vinsExistentesenVisita(idCliente: number, datos: string[], codigovisitaext: string) {
    this.updateToken();
    return this.http.post(this.URL_InspeccionTotal + 'v1/visita/validarvinsExistentesenVisita/' + idCliente,
       { datos, codigovisitaext },
        this.httpOptionsABM)
      .pipe(
        catchError(this.handleError)
      );
  }

  //#endregion



  handleError(error) {
    let errorMessage = '';
    // window.alert(error.error);
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    // window.alert(errorMessage);
    return throwError(errorMessage);
  }
  handleErrorInf(error) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.error.errors[0].message}`;
    }
    window.alert(errorMessage);
    return throwError(errorMessage);
  }
  handleErrorInfsinAlert(error) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `${error.error.errors[0].message}`;
    }
    return throwError(errorMessage);
  }
  //#endregion

}
